import { useLocation, useHistory } from 'react-router-dom';
import { useEffect } from "react";
import { Helmet } from "react-helmet";

const CloudPayments = () => {
  const location = useLocation();
  const history = useHistory();
  
  const onStart = () => {
    const params = new URLSearchParams(location.search);
    const allParams = Object.fromEntries(params.entries());
    // console.log('Все параметры:', allParams);
    // console.log("Подписка", allParams.autopay ? allParams.clientId : null);
    const payments = new window.cp.CloudPayments({
      language: "ru-RU",
      email: allParams.email ? allParams.email : "",
      applePaySupport: false,
      googlePaySupport: false,
      yandexPaySupport: false,
      tinkoffPaySupport: false,
      tinkoffInstallmentSupport: false,
      sbpSupport: false
    })

    payments.pay("charge", {
      publicId: allParams.publicId,
      description: allParams.description,
      amount: Number(allParams.amount)/100,
      currency: "RUB",
      invoiceId: allParams.orderId,
      accountId: allParams.autopay ? allParams.clientId : null,
      email: allParams.email ? allParams.email : "",
      skin: "classic",
      //requireEmail: false,
      //  phone: allParams.phone,
    }).then(function(widgetResult) {
        // console.log('result', widgetResult);
        history.push("./purchases");
    }).catch(function(error) {
        // console.log('error', error);
        history.push("./catalog");
    });
    history.replace(location.pathname);
  }
  
  useEffect(() => {
    const checkScript = () => {
      if (window.cp) {
        onStart(); // Вызываем функцию
      } else {
        setTimeout(checkScript, 100); // Проверяем каждые 100мс
      }
    };

    checkScript();
  }, []);

  //useEffect(onStart, [location]);
  

  return<div>
      <Helmet><script src="https://widget.cloudpayments.ru/bundles/cloudpayments.js" async /></Helmet>
  </div>
}

export default CloudPayments;